/** Facilitator shell queries that must settle after an org switch. */
export const FACILITATOR_ORG_SWITCH_QUERY_ROOTS = [
  'facilitatorDashboard',
  'trainingSprints',
  'upcoming-activities'
] as const

/** Gamer shell queries that must settle after an org switch. */
export const GAMER_ORG_SWITCH_QUERY_ROOTS = ['upcoming-activities-gamer-list'] as const

export const ORG_SWITCH_MAX_WAIT_MS = 15_000

export const ORG_SWITCH_OVERLAY_Z_INDEX = 10_000

export type OrgSwitchShellRole = 'facilitator' | 'gamer' | 'unknown'

export function deriveOrgSwitchShellRole(pathname: string): OrgSwitchShellRole {
  if (pathname.startsWith('/facilitator')) return 'facilitator'
  if (pathname.startsWith('/gamer')) return 'gamer'
  return 'unknown'
}

export function getOrgSwitchQueryRootsForRole(role: OrgSwitchShellRole): readonly string[] {
  switch (role) {
    case 'facilitator':
      return FACILITATOR_ORG_SWITCH_QUERY_ROOTS
    case 'gamer':
      return GAMER_ORG_SWITCH_QUERY_ROOTS
    default:
      return [...FACILITATOR_ORG_SWITCH_QUERY_ROOTS, ...GAMER_ORG_SWITCH_QUERY_ROOTS]
  }
}

export function isCriticalOrgSwitchQuery(queryKey: unknown, role: OrgSwitchShellRole, targetOrgId: string): boolean {
  if (!Array.isArray(queryKey) || queryKey.length === 0) {
    return false
  }
  const root = queryKey[0]
  if (typeof root !== 'string') {
    return false
  }
  const roots = getOrgSwitchQueryRootsForRole(role)
  if (!(roots as readonly string[]).includes(root)) {
    return false
  }
  return queryKey.includes(targetOrgId)
}
